<template>
    <div id="pay">
        <div>
            <el-card>
                <el-row :gutter="20">
                    <el-col :span="this.$store.state.elColNum">
                        <el-form ref="form" :model="form" :label-width="this.$store.state.setLabelWidth" size="small">
                            <el-divider content-position="left">微信支付设置</el-divider>
                            <el-form-item label="微信开放平台AppID">
                                <el-input v-model="form.appid"></el-input>
                            </el-form-item>
                            <el-form-item label="微信开放平台AppSecret">
                                <el-input v-model="form.appSecret"></el-input>
                            </el-form-item>
                            <el-form-item label="微信公众平台AppId">
                                <el-input v-model="form.wechat_official_appid"></el-input>
                            </el-form-item>
                            <el-form-item label="微信公众平台AppSecret">
                                <el-input v-model="form.wechat_official_appsecret"></el-input>
                            </el-form-item>
                            <el-form-item label="微信商户号">
                                <el-input v-model="form.mchid"></el-input>
                            </el-form-item>
                            <el-form-item label="微信密钥key">
                                <el-input v-model="form.mchkey"></el-input>
                            </el-form-item>
                            <el-form-item label="是否开启">
                                <el-switch
                                        v-model="form.wxpay_switch"
                                        active-value="1"
                                        inactive-value="0">
                                </el-switch>
                            </el-form-item>
                            <el-divider content-position="left">支付宝支付设置</el-divider>
                            <el-form-item label="支付宝AppID">
                                <el-input v-model="form.aliapp_appid"></el-input>
                            </el-form-item>
                            <el-form-item label="支付宝合作者身份ID">
                                <el-input v-model="form.aliapp_partner"></el-input>
                            </el-form-item>
                            <el-form-item label="支付宝登录账号">
                                <el-input v-model="form.aliapp_seller_id"></el-input>
                            </el-form-item>
                            <el-form-item label="支付宝公钥">
                                <el-input v-model="form.alipayrsaPublicKey" type="textarea" :autosize="{  maxRows: 6}"></el-input>
                            </el-form-item>
                            <el-form-item label="支付宝安卓密钥">
                                <el-input v-model="form.aliapp_key_android" type="textarea" :autosize="{  maxRows:6}"></el-input>
                            </el-form-item>
                            <el-form-item label="支付宝苹果密钥">
                                <el-input v-model="form.aliapp_key_ios" type="textarea" :autosize="{ maxRows: 6}"></el-input>
                            </el-form-item>
                            <el-form-item label="是否开启">
                                <el-switch
                                        v-model="form.alipay_switch"
                                        active-value="1"
                                        inactive-value="0">
                                </el-switch>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">保存</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </el-card>
        </div>
    </div>
</template>

<script>
  export default {
    name: "pay",
    data() {
      return {
        form: {
          appid: '',
          appSecret: '',
          mchid: '',
          mchkey: '',
          wechat_official_appid:'',
          wechat_official_appsecret:'',
          wxpay_switch: '0',
          alipay_switch: '0',
          aliapp_partner: '',
          aliapp_seller_id: '',
          aliapp_key_android: '',
          aliapp_key_ios: '',
          alipayrsaPublicKey: '',
          aliapp_appid: '',
        },
      }
    },
    created() {
      this.getData()
    },
    methods: {
      getData() {
        this.$axios.post('admin/config/pay', '').then((res) => {
          this.form = res.data;
        });
      },
      onSubmit() {
        this.$axios.post('admin/config/pay_set', {config: this.form}).then((res) => {
          this.$message.success('成功');
          this.getData();
          this.visible = false
        });
      },
    }
  }
</script>

<style scoped>

</style>